import { createAction, props } from '@ngrx/store';
import { TermsResponse } from '../../../domain/models/terms.model';

export const loadLegalTerms = createAction('[Legal] Load Terms');
export const loadLegalTermsSuccess = createAction('[Legal] Load Terms Success', props<{ terms: TermsResponse }>());
